import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './modules/core/auth/auth.guard';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'file-manager',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: './modules/core/auth/auth.module#AuthModule'
    },
    {
        path: 'file-manager',
        loadChildren: './modules/file-manager/file-manager.module#FileManagerModule',
        canActivate: []
    },
    //{path: 'external', loadChildren: './modules/file-manager/file-manager.module#FileManagerModule', canActivate: [ExternalGuard] }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
